import { bgcolor, margin, minHeight } from "@mui/system";

const styles = () => ({
  modal: {
    borderRadius: "16px",
    width: " 90%",
    maxWidth: "463px",
    bgcolor: "background.paper",
    height: "600px",
    overflowY: "auto",
    overflowX: "hidden",
    minHeight: "",
    margin: "10px 0 0 0",
  },
  boxImg: {
    width: "101%",
    display: "block",
    overflow: "hidden",
    flexShrink: 0,
    flexGrow: 0,
    ml: -0.5,
  },
  boxComponent: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
  containerQuestion: {
    width: "100%",
    p: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1,
  },
  boxComentario: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "10px",
    padding: "0 60px",
  },
  containerDescriptionQuestion: {
    width: "100%",
    display: "flex",
    alignItems: "start",
  },
  containerButtons: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px",
  },
  containerChipsSelect: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    padding: "8px",
    alignItems: "center",
    justifyContent: "center",
  },
});

export default styles;
